import { CommonModule } from "@angular/common";
import { TranslatePipe } from "@app/shared/i18n/translation-scope";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { SharedModule } from "@app/shared/shared.module";
import { RiskControlsComponent } from "./pages/detail/risk-detail/risk-controls/risk-controls.component";
import { RiskDatamanagementComponent } from "./pages/detail/risk-detail/risk-datamanagement/risk-datamanagement.component";
import { RiskDetailMainComponent } from "./pages/detail/risk-detail/risk-detail-main/risk-detail-main.component";
import { RiskImpactScalesComponent } from "./pages/detail/risk-detail/risk-detail-main/risk-impact-scales/risk-impact-scales.component";
import { RiskQuantitativeScoringComponent } from "./pages/detail/risk-detail/risk-detail-main/risk-quantitative-scoring/risk-quantitative-scoring.component";
import { RiskDetailComponent } from "./pages/detail/risk-detail/risk-detail.component";
import { RiskEventsComponent } from "./pages/detail/risk-detail/risk-events/risk-events.component";
import { RiskMoiComponent } from "./pages/detail/risk-detail/risk-mois/risk-mois.component";
import { RiskPeriodScoreChartComponent } from "./pages/detail/risk-detail/risk-result-overview/risk-period-score-chart/risk-period-score-chart.component";
import { RiskResultOverviewComponent } from "./pages/detail/risk-detail/risk-result-overview/risk-result-overview.component";
import { RiskOverviewComponent } from "./pages/risk-overview/risk-overview.component";
import { RiskDataService } from "./services/RiskDataService";
import { RiskThirdpartyComponent } from "./pages/detail/risk-detail/risk-thirdparty/risk-thirdparty.component";
import { RiskKriComponent } from "./pages/detail/risk-detail/risk-kri/risk-kri.component";
import { LinkedAssetsComponent } from "@app/shared/components/assetmanagement/linked-assets/linked-assets.component";
import { CerrixDropAreaComponent } from "@app/shared/cerrix-documents/cerrix-drop-area/cerrix-drop-area.component";
import { CerrixWorkflowBarComponent } from "@app/shared/cerrix-workflow-bar/cerrix-workflow-bar.component";
import { CerrixPageFooterComponent } from "@app/shared/cerrix-page-footer/cerrix-page-footer.component";
import { CerrixInstructionsIconComponent } from "@app/shared/cerrix-instructions-icon/cerrix-instructions-icon.component";
import { CerrixDialogComponent } from "@app/shared/organisms/cerrix-dialog/cerrix-dialog.component";
import { CerrixButtonComponent } from "@app/shared/atoms/cerrix-button/cerrix-button.component";
import { RiskGenerateAiComponent } from "./pages/generate-ai/risk-generate-ai.component";
import { RiskGenerateAiOverviewComponent } from "./pages/generate-ai-overview/risk-generate-ai-overview.component";
import { CerrixPaginationComponent } from "@app/shared/molecules/cerrix-pagination/cerrix-pagination.component";
import { CerrixConfirmDialogComponent } from "@app/shared/organisms/cerrix-confirm-dialog/cerrix-confirm-dialog.component";
import { CerrixShowTotalItemsComponent } from "@app/shared/molecules/cerrix-show-total-items/cerrix-show-total-items.component";
import { CerrixAcceptRejectToggleComponent } from "@app/shared/molecules/cerrix-accept-reject-toggle/cerrix-accept-reject-toggle.component";
import { CerrixInputGroupComponent } from "@app/shared/molecules/cerrix-input-group/cerrix-input-group.component";
import { CerrixTextareaGroupComponent } from "@app/shared/molecules/cerrix-textarea-group/cerrix-textarea-group.component";
import { CerrixAddAndFilterBarComponent } from "@app/shared/molecules/cerrix-add-and-filter-bar/cerrix-add-and-filter-bar.component";
import { GenerateAiRisksDialogComponent } from "./shared/dialog/generate-ai-risks-dialog/generate-ai-risks-dialog.component";
import { AddNewRiskDialogComponent } from "./shared/dialog/add-new-risk-dialog/add-new-risk-dialog.component";
import { CerrixFilteredGenericListManagerComponent } from "@app/shared/organisms/cerrix-filtered-generic-list-manager/cerrix-filtered-generic-list-manager.component";
import { CerrixHeaderComponent } from "@app/shared/molecules/cerrix-header/cerrix-header.component";
import { CerrixBannerComponent } from "@app/shared/atoms/cerrix-banner/cerrix-banner.component";

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        SharedModule,
        RiskDetailComponent,
        RiskResultOverviewComponent,
        RiskOverviewComponent,
        RiskDetailMainComponent,
        RiskControlsComponent,
        RiskKriComponent,
        RiskDatamanagementComponent,
        RiskEventsComponent,
        RiskGenerateAiOverviewComponent,
        LinkedAssetsComponent,
        CerrixDialogComponent,
        CerrixConfirmDialogComponent,
        CerrixButtonComponent,
        CerrixPaginationComponent,
        CerrixShowTotalItemsComponent,
        CerrixDropAreaComponent,
        CerrixWorkflowBarComponent,
        CerrixPageFooterComponent,
        CerrixInstructionsIconComponent,
        CerrixAcceptRejectToggleComponent,
        CerrixInputGroupComponent,
        CerrixTextareaGroupComponent,
        CerrixHeaderComponent,
        CerrixAddAndFilterBarComponent,
        CerrixFilteredGenericListManagerComponent,
        CerrixBannerComponent,
        TranslatePipe,
        RiskImpactScalesComponent,
        RiskMoiComponent,
        RiskPeriodScoreChartComponent,
        RiskQuantitativeScoringComponent,
        RiskThirdpartyComponent,
        RiskGenerateAiComponent,
        GenerateAiRisksDialogComponent,
        AddNewRiskDialogComponent,
    ],
})
export class RiskModule {
    static forRoot(): ModuleWithProviders<RiskModule> {
        return {
            ngModule: RiskModule,
            providers: [RiskDataService],
        };
    }
}
